import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';

const linee = [
  {
    title: 'Linee vita fisse',
    subtitle: 'Una protezione permanente per il tuo edificio.',
    image: '/brochure/linee-vita-fisse.jpg',
    points: ['Progettazione e installazione a norma UNI EN 795', 'Soluzioni su misura per ogni copertura', 'Materiali certificati e di alta qualità', 'Valorizzano e mettono in sicurezza l\u2019immobile'],
  },
  {
    title: 'Linee vita provvisorie',
    subtitle: 'La soluzione ideale per interventi temporanei.',
    image: '/brochure/linee-vita-provvisorie.jpg',
    points: ['Installazione rapida e sicura', 'Ideali per manutenzioni di breve durata', 'Sistemi certificati e collaudati', 'Massima flessibilità in cantiere'],
  },
];

const dispositivi = [
  { img: '/brochure/disp-imbracatura.jpg', label: 'Imbracatura anticaduta' },
  { img: '/brochure/disp-cordini.jpg', label: 'Cordini e dissipatori' },
  { img: '/brochure/disp-retrattile.jpg', label: 'Dispositivi retrattili' },
  { img: '/brochure/disp-casco.jpg', label: 'Caschi di protezione' },
  { img: '/brochure/disp-ancoraggio.jpg', label: 'Ancoraggi certificati' },
  { img: '/brochure/disp-kit.jpg', label: 'Kit linee vita provvisorie' },
];

const SafetySection = () => (
  <section id="sicurezza" className="py-24 md:py-32 bg-[#0F172A]" data-testid="safety-section">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
        <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 bg-emerald-500/15 border border-emerald-500/25 rounded-full">
          <ShieldCheck className="w-4 h-4 text-emerald-400" />
          <span className="text-emerald-400 font-medium text-sm">Lavorare in sicurezza è la nostra priorità</span>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">Sicurezza sempre al primo posto</h2>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">Installiamo linee vita fisse o provvisorie e utilizziamo dispositivi certificati per lavorare in quota nel pieno rispetto delle normative.</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
        {linee.map((l, i) => (
          <motion.div key={l.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2">
              <div className="h-56 sm:h-full overflow-hidden">
                <img src={l.image} alt={l.title} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-white mb-1" style={{ fontFamily: 'Outfit' }}>{l.title}</h3>
                <p className="text-sm text-slate-400 mb-4">{l.subtitle}</p>
                <ul className="space-y-2">
                  {l.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-slate-300">
                      <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-8">
        <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>I dispositivi di sicurezza che utilizziamo</h3>
        <p className="text-slate-400 text-sm mt-2">Solo attrezzature certificate, sempre in perfetto stato ed efficienti.</p>
      </motion.div>
      <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
        {dispositivi.map((d, i) => (
          <motion.div key={d.label} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }} className="bg-white rounded-xl p-3 text-center">
            <img src={d.img} alt={d.label} loading="lazy" className="w-full h-20 object-contain mb-2" />
            <span className="text-[11px] font-medium text-slate-600 leading-tight block">{d.label}</span>
          </motion.div>
        ))}
      </div>
      <p className="text-center text-sm text-slate-500 mt-8">Tutti i nostri dispositivi sono certificati e controllati periodicamente, nel rispetto delle normative vigenti.</p>
    </div>
  </section>
);

export default SafetySection;
